import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { LoggerService } from '@core/services/logger.service';
import { UserService } from '@core/services/user.service';
import { map } from 'rxjs';

export const authGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  return userService.getOrFetchIsUserInAnyGroup().pipe(
    map(isUserInAnyGroup => {
      if (isUserInAnyGroup) {
        return true;
      }

      // The frontend-side twin of the backend ForbiddenExceptionFilter logging — without this, a denied
      // navigation left no trail of which URL was attempted or why.
      logger.warn('AuthGuardBlocked', { attemptedUrl: state.url, reason: 'NotInAnyGroup' });
      return router.createUrlTree(['/access-denied']);
    })
  );
};
